import { useEffect, useState } from "react";
import { Loader2, HeartHandshake } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import PublicCaseCard from "@/components/PublicCaseCard";
import api from "@/lib/api";

export default function PublicCases() {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/cases").then((res) => {
      setCases(res.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen bg-amtm-bg">
      <PublicHeader />
      <section className="max-w-6xl mx-auto px-6 md:px-12 py-12 md:py-20">
        <div className="text-center mb-12">
          <HeartHandshake className="h-10 w-10 text-amtm-teal mx-auto mb-4" />
          <h1 className="font-display text-4xl sm:text-5xl text-amtm-text mb-4">Animals That Need Your Help</h1>
          <p className="text-amtm-textMuted max-w-xl mx-auto">
            These animals are currently under our care. Your donation directly funds their treatment and recovery.
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-16" data-testid="public-cases-loading">
            <Loader2 className="h-8 w-8 animate-spin text-amtm-teal" />
          </div>
        ) : cases.length === 0 ? (
          <p className="text-center text-amtm-textMuted py-16" data-testid="public-cases-empty">
            No cases are public right now. Please check back soon.
          </p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="public-cases-grid">
            {cases.map((c) => (
              <PublicCaseCard key={c.id} caseItem={c} />
            ))}
          </div>
        )}
      </section>
      <PublicFooter />
    </div>
  );
}
